<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormJobListingCandidate
      :JobListingCandidate="editJobListingCandidate"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({ name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormJobListingCandidate from '../components/FormJobListingCandidate.vue';

export default {
  components: {
    FormJobListingCandidate,
  },
  name: 'EditJobListingCandidate',
  module: 'Candidates',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing JobListingCandidate. Default to {}.
      */
      editJobListingCandidate: {},
      /**
       * Query Id for JobListingCandidate
       */
      jobListingCandidateId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('jobListingCandidates', ['jobListingCandidates', 'jobListingCandidate']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.jobListingCandidateId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_jobListingCandidate(this.jobListingCandidateId);
      this.editJobListingCandidate = this.jobListingCandidate;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('jobListingCandidates', ['LOAD_jobListingCandidate', 'CREATE_jobListingCandidate', 'UPDATE_jobListingCandidate']),
    /** Method used to save the item
     */
    async save(jobListingCandidate) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_jobListingCandidate(jobListingCandidate);
      } else {
        await this.UPDATE_jobListingCandidate(jobListingCandidate);
      }
      this.isSaving = false;
      this.$router.push({ name: 'job-listing-candidate-ListJobListingCandidate' });
    },
  },
};
</script>

<docs>
# EditJobListingCandidate example

'''js
<EditJobListingCandidate :JobListingCandidate="JobListingCandidate" />
'''
</docs>
